/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LTI1p3ProviderPresentationAsJSONParser = 
/* #__PURE__ */ parsers.object([
    [
        'preferredFrameHeight',
        /* #__PURE__ */ parsers.maybeNull(codecNumber),
        'preferred_frame_height',
    ],
]);
export class LTI1p3ProviderPresentationAsJSON extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LTI1p3ProviderPresentationAsJSONParser.decode(input).map(res => new LTI1p3ProviderPresentationAsJSON(res));
    }
    static unsafeDecode(input) {
        return LTI1p3ProviderPresentationAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LTI1p3ProviderPresentationAsJSONParser.encode(data);
    }
    static schema() {
        return LTI1p3ProviderPresentationAsJSONParser.schema();
    }
}
